import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import React, { useContext, useState } from "react";
import { UserContext } from "../contexts/UserContext";

export default function CreateBanner(props) {
  const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "570px",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + " " + time;
  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const [visitorPitcher, setVisitorPitcher] = React.useState("");
  const [homePitcher, setHomePitcher] = React.useState("");
  const [shortGame, setShortGame] = React.useState(false);
  const [dateChanged, setDateChanged] = React.useState(false);
  const [timeChanged, setTimeChanged] = React.useState(false);
  const [pitcherChanged, setPitcherChanged] = React.useState(0);
  const [period, setPeriod] = React.useState(0);
  const [idEvent, setIdEvent] = React.useState(0);
  const [idBannerType, setIdBannerType] = React.useState(0);
  const [description, setDescription] = React.useState(0);
  const [visitorTeam, setVisitorTeam] = React.useState("");
  const [homeTeam, setHomeTeam] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [withCapsOn, setWithCapsOn] = useState(true);

  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("userInfo"))
  );
  const [result, setResult] = React.useState(0);

  const handleChangeDescription = (event) => {
    setDescription(event.target.value);
  };

  const handleChangeVisitorTeam = (event) => {
    setVisitorTeam(event.target.value);
  };

  const handleChangeHomeTeam = (event) => {
    setHomeTeam(event.target.value);
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };
  const handleOk = async () => {
    let responseData = 0;
    for (let i = 0; i < props.IdGames.length; i++) {
      let gameRequest = {
        IdSport: props.IdSport,
        IdLeague: props.IdLeague,
        GameDateTime: dateTime,
        VisitorNumber: props.VisitorNumber,
        HomeNumber: props.HomeNumber,
        VisitorTeam: withCapsOn ? visitorTeam.toUpperCase() : visitorTeam,
        HomeTeam: withCapsOn ? homeTeam.toUpperCase() : homeTeam,
        VisitorScore: -1,
        HomeScore: -1,
        VisitorPitcher: visitorPitcher,
        HomePitcher: homePitcher,
        NormalGame: 0,
        GameStat: "B",
        Graded: 0,
        IdGameType: 227,
        Hookups: 0,
        Local: 1,
        Online: 1,
        ShortGame: shortGame,
        EventDate: dateTime,
        DateChanged: dateChanged,
        TimeChanged: timeChanged,
        PitcherChanged: pitcherChanged,
        Period: period,
        ParentGame: props.IdGames[i],
        GradedDate: dateTime,
        NumTeams: 2,
        IdEvent: idEvent,
        FamilyGame: props.IdGames[i],
        HasChildren: 0,
        IdTeamVisitor: -1,
        IdTeamHome: -1,
        IdBannerType: idBannerType,
        Description: description,
        AcceptAutoChanges: 1,
        IdUser: userInfo.userId,
        Result: result,
      };
      console.log(gameRequest);
      await axios({
        method: "post",
        url: process.env.REACT_APP_API2_URL + "/Game/InsertGame",
        //url: 'https://localhost:44337/api/Game/InsertGame',
        data: gameRequest,
      }).then((response) => {
        console.log("response", response);
        responseData = response.data;
      });
    }
    if (responseData != 0) {
      props.clearArray();
      props.searchGameValues();
      handleClose();
    }
  };

  return (
    <React.Fragment>
      <Dialog open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              New Banner
            </Typography>
            <IconButton>
              <FormControlLabel
                style={{ color: "#111827" }}
                label="Insert Caps"
                control={
                  <Checkbox
                    checked={withCapsOn}
                    onChange={() => {
                      setWithCapsOn(!withCapsOn);
                    }}
                    name="InsertCaps"
                    color="secondary"
                  />
                }
              />
            </IconButton>
          </Toolbar>
        </AppBar>
        {loading ? (
          <CircularProgress style={{ margin: "0 auto" }} />
        ) : (
          <React.Fragment>
            <br />
            <form className={classes.center}>
              <FormGroup row>
                <TextField
                  fullWidth
                  type="text"
                  label="Description"
                  value={description}
                  multiline={true}
                  rows="4"
                  onChange={handleChangeDescription}
                  variant="outlined"
                />
              </FormGroup>
              <FormGroup row>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Top Line"
                  value={visitorTeam}
                  multiline={true}
                  onChange={handleChangeVisitorTeam}
                />
              </FormGroup>
              <FormGroup row>
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Bottom Line"
                  value={homeTeam}
                  multiline={true}
                  onChange={handleChangeHomeTeam}
                />
              </FormGroup>
            </form>
          </React.Fragment>
        )}
        <DialogActions>
          <Button
            color="inherit"
            startIcon={<CancelIcon />}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            startIcon={<SaveIcon />}
            variant="contained"
            color="primary"
            onClick={handleOk}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
